export const formatDurationHours = (hours: number | null | undefined): string => {
  if (hours == null || !isFinite(hours)) return "—";

  const h = Math.max(0, hours);

  if (h === 0) return "0 sec";

  if (h < 1 / 60) {
    const secs = Math.max(1, Math.round(h * 3600));

    return `${secs} sec`;
  }

  if (h < 1) {
    const mins = h * 60;

    return mins < 10 ? `${mins.toFixed(1)} min` : `${Math.round(mins)} min`;
  }

  if (h < 48) {
    return h < 10 ? `${h.toFixed(1)} h` : `${Math.round(h)} h`;
  }

  const days = h / 24;

  return days < 10 ? `${days.toFixed(1)} d` : `${Math.round(days)} d`;
};
